import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from '../../main-layout/main-layout.component';
import { MainLayoutModule } from '../../main-layout/main-layout.module';
import { LoginPopupComponent } from '../login-popup/login-popup.component';
import { LoginPageComponent } from './login-page.component';


const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            {
                path: '',
                component: LoginPageComponent,
                children: [
                    {
                        path: '',
                        component: LoginPopupComponent,
                        data: {
                            minimalHedaer: true,
                            loginWithMaxMode: false,
                            loginPageMode: true
                        }
                    }
                ]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes), MainLayoutModule],
    exports: [RouterModule]
})
export class LoginPageRoutingModule { }
